// Wyrównanie wysokości boxów w sekcji "Dziedziny" na stronie głównej
// Bazuje na najwyższym .box-container__wrapper w sliderze fieldsSwiper

document.addEventListener('DOMContentLoaded', () => {
    const initEqualHeightFields = () => {
        const wrappers = Array.from(document.querySelectorAll('.fieldsSwiper .box-container__wrapper'));
        if (!wrappers.length) return;

        // Reset wysokości, żeby poprawnie przeliczyć przy zmianie szerokości
        wrappers.forEach((el) => {
            el.style.height = 'auto';
        });

        let maxHeight = 0;
        wrappers.forEach((el) => {
            const rect = el.getBoundingClientRect();
            if (rect && rect.height > maxHeight) {
                maxHeight = rect.height;
            }
        });

        if (!maxHeight) return;

        wrappers.forEach((el) => {
            el.style.height = `${maxHeight}px`;
        });
    };

    // Pierwsze uruchomienie po załadowaniu DOM (Swiper może jeszcze układać slajdy)
    initEqualHeightFields();

    // Dodatkowo po pełnym załadowaniu (obrazy w tle boxów mogą zmieniać layout)
    window.addEventListener('load', initEqualHeightFields);

    // Reakcja na zmianę rozmiaru okna / breakpointy
    window.addEventListener('resize', () => {
        // Debounce prosty przez requestAnimationFrame
        window.requestAnimationFrame(initEqualHeightFields);
    });
});
